import React from 'react';

import { StyledDot } from './Dot.styles';

import { DotProps } from './Dot.types';

const Dot = ({
  isSelected,
  index,
  sliderDispatch,
  srOnlyTextFunction = (index) => `Go to slide ${index}`,
  children = null,
  componentClassname = 'dot',
  customClassnames = '',
}: DotProps) => {
  return (
    <StyledDot
      className={`${componentClassname} ${customClassnames} ${
        isSelected ? `${componentClassname}--is-selected` : ''
      }`}
      aria-current={isSelected ? 'true' : 'false'}
      onClick={() =>
        sliderDispatch({
          type: 'goto',
          payload: { newSlideIndex: index, source: 'dot' },
        })
      }
    >
      {children}
      <span className="sr-only">{srOnlyTextFunction(index)}</span>
    </StyledDot>
  );
};
Dot.displayName = 'Dot';

export default Dot;
